export default "__VITE_ASSET__d5eb36ec__"